<template>
  <div class="sys_tip_outer">
    <div class="quick-tpis">
      <marquee behavior="scroll" onmouseover="this.stop()" onmouseout="this.start()">{{config_info.notice}}   </marquee>
    </div>
  </div>
</template>

<script>
  // import { indexResource } from '@/resource/resource'
  import { mapState } from 'vuex'

  export default {
    name: 'affiche',
    data () {
      return {
        // app_marquee: ''
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
    },
    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .sys_tip_outer
    height 30px
    background-color rgb(237,237,237)
    .quick-tpis
      width 1210px
      margin 0 auto
      line-height 30px
      color #c51e32
      font-size 12px
</style>



// WEBPACK FOOTER //
// affiche.vue?898ab72e